import { Card, CardBody, CardHeader, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Swal from 'sweetalert2'
import { FormatMoney } from 'format-money-js'
import Autosuggest from 'react-autosuggest';
import { useContext, useState, useEffect, useRef } from "react";
import "./css/Venta.css"
import { Event, event } from "jquery";
import { jsPDF } from "jspdf";
import Icono from './images/blanco.png'
import { QRCode } from 'react-qrcode-logo';
import { renderToStaticMarkup } from "react-dom/server"
import ReactDOMServer from 'react-dom/server';
import { Autocomplete, TextField } from '@mui/material';
import { Try } from "@mui/icons-material";
const tabespacio = '\u00A0';
const modeloPais = {
    codigo: "",
    nombre: "",
}
const Tipopodf = (props) => {
    const [fm, setfm] = useState(new FormatMoney({ symbol: '' }));
    const [fm1, setfm1] = useState(new FormatMoney({ symbol: '', decimals: 1 }));
    const [fm2, setfm2] = useState(new FormatMoney({ symbol: '', decimals: 2 }));
    const [fm3, setfm3] = useState(new FormatMoney({ symbol: '$', decimals: 2 }));
    const [ivadiscriminado, setivadiscriminado] = useState([])
    useEffect(() => {


    }, [])

    const calculartotalesmovimientoivadiscriminado = (_enviodatos2) => {
        if (props.iva > 0) {
            try {

                var totalesiva = []
                _enviodatos2.map((dato, index) => {
                    var bruto = 0
                    var descuento = 0
                    var subtotal = 0
                    var cantidad = Number(dato.cantidad)
                    var precio = Number(dato.precio)
                    var pordescuento = Number(dato.pordescuento)
                    var iva = 0
                    bruto = (cantidad * precio)
                    descuento = bruto * (pordescuento / 100)
                    subtotal = bruto - descuento
                    var poriva = Number(dato.poriva)

                    iva = subtotal * (poriva / 100)
                    if (poriva > 0) {
                        var fbuss = totalesiva.filter(p => p.porcentaje == poriva)
                        if (fbuss.length == 0) {
                            var ivadi = {
                                porcentaje: poriva,
                                valor: iva
                            }
                            totalesiva.push(ivadi)

                        } else {
                            var posicion = totalesiva.findIndex(item => item.porcentaje === poriva)
                            if (posicion !== -1) {
                                totalesiva[posicion].valor += iva
                            } else {
                                var ivadi = {
                                    porcentaje: poriva,
                                    valor: iva
                                }
                                totalesiva.push(ivadi)
                            }
                        }

                    }
                })

                setivadiscriminado(totalesiva)
            } catch (error) {

            }
        }
    }

    function calcularDigitoVerificacion(myNit) {
        try {
            var vpri,
                x,
                y,
                z;

            // Se limpia el Nit
            myNit = myNit.replace(/\s/g, ""); // Espacios
            myNit = myNit.replace(/,/g, ""); // Comas
            myNit = myNit.replace(/\./g, ""); // Puntos
            myNit = myNit.replace(/-/g, ""); // Guiones

            // Se valida el nit
            if (isNaN(myNit)) {
                console.log("El nit/cédula '" + myNit + "' no es válido(a).");
                return "";
            };

            // Procedimiento
            vpri = new Array(16);
            z = myNit.length;

            vpri[1] = 3;
            vpri[2] = 7;
            vpri[3] = 13;
            vpri[4] = 17;
            vpri[5] = 19;
            vpri[6] = 23;
            vpri[7] = 29;
            vpri[8] = 37;
            vpri[9] = 41;
            vpri[10] = 43;
            vpri[11] = 47;
            vpri[12] = 53;
            vpri[13] = 59;
            vpri[14] = 67;
            vpri[15] = 71;

            x = 0;
            y = 0;
            for (var i = 0; i < z; i++) {
                y = (myNit.substr(i, 1));
                // console.log ( y + "x" + vpri[z-i] + ":" ) ;

                x += (y * vpri[z - i]);
                // console.log ( x ) ;
            }

            y = x % 11;
            // console.log ( y ) ;

            return (y > 1) ? 11 - y : y;
        } catch (error) {
            return ""
        }
    }

    const buscarnombremediopago = (codigo) => {
        var medd = props.mediopagos.filter(p => p.codigo == codigo)
        if (medd.length != 0) {
            return medd[0].nombre
        } else {
            return "Transferencia"
        }
    }
    const totalunidades = () => {
        var tot = 0
        for (let i = 0; i < props.Movimiento.famovimiento.length; i++) {
            const element = props.Movimiento.famovimiento[i];
            tot = tot + element.cantidad
        }
        return tot
    }
    return (
        <Modal size="lg" isOpen={props.previsualizar} onOpened={(e) => {
            if (props.tipodocumento.busplu == "si") {
                props.previsualizarpdf()

                if (!props.plantillapdf.estoybuscando) {
                    if (props.tipodocumento.facturapap != "electronica") {
                        // props.setprevisualizar(false)

                    } else {
                        if (props.tipodocumento.docauto == "si") {
                            // props.enviocorreofacturaelectronica()

                        }
                        // props.setprevisualizar(false)
                    }

                }
            } else {
                if (props.tipodocumento.docauto == "si" && props.tipodocumento.facturapap == "electronica") {
                    props.enviocorreofacturaelectronica()

                }
            }
            calculartotalesmovimientoivadiscriminado(props.Movimiento.famovimiento)
        }}>
            <ModalHeader>
                Opciones
            </ModalHeader>
            <ModalBody id={"pruebapdfventaelectronica"} >
                <Row >
                    <Col sm={12}>
                        <Row>
                            <Col sm={4} style={{ textAlign: 'center', fontSize: props.plantillapdf.tamanoletraencabezado, fontWeight: 'normal' }}>
                                {props.plantillapdf.mostrarlogo && <img src={"imagen/" + (props.sucursal.nombrecomercial ? (props.sucursal.nombrecomercial.toLowerCase().includes(".png") || props.sucursal.nombrecomercial.toLowerCase().includes(".jpg") ? props.sucursal.nombrecomercial : JSON.parse(props.user).empresa.config.ruta_logo) : JSON.parse(props.user).empresa.config.ruta_logo)} alt="Image" style={{ width: '200px', borderRadius: '10px' }} />}<br />
                            </Col>
                            <Col sm={4} style={{ textAlign: 'center', fontSize: props.plantillapdf.tamanoletraencabezado, fontWeight: 'normal', color: props.plantillapdf.colorletra, fontFamily: 'Arial,monospace' }}>
                                {props.plantillapdf.nombrereal && JSON.parse(props.user).empresa.empresa.nombre} {props.plantillapdf.nombrereal && <br />}
                                {!props.plantillapdf.nombrereal && (props.sucursal && props.sucursal.nit != "" ? props.sucursal.nombre : JSON.parse(props.user).empresa.config.encabezado_pdf)} {!props.plantillapdf.nombrereal && <br />}
                                {props.plantillapdf.nit && ("Nit: " + (props.sucursal && props.sucursal.nit != "" ? props.sucursal.nit : JSON.parse(props.user).empresa.empresa.nit + " - " + calcularDigitoVerificacion(JSON.parse(props.user).empresa.empresa.nit)))} {props.plantillapdf.nit && <br />}{/* {"Direccion: " + JSON.parse(props.user).empresa.empresa.direccion}<br /> */}
                                {props.tipodocumento.mcheque}<br />
                                {props.plantillapdf.telefono && ("Telefonos: " + (props.sucursal && props.sucursal.nit != "" ? props.sucursal.telefono : JSON.parse(props.user).empresa.empresa.telefono) + " - " + (props.sucursal && props.sucursal.nit != "" ? props.sucursal.celular : JSON.parse(props.user).empresa.empresa.celular))}{props.plantillapdf.telefono && (<br />)}
                                {/* {"Email: " + JSON.parse(props.user).empresa.empresa.email}<br /> */}
                                {props.plantillapdf.mostrarcufe &&
                                    <Col sm={12} style={{ textAlign: 'center', fontSize: '10px', color: 'black' }}>

                                        {"Cufe:"}<br />
                                        {props.Movimiento.cufe && props.Movimiento.cufe.substring(0, props.Movimiento.cufe.length / 2)}<br />
                                        {props.Movimiento.cufe && props.Movimiento.cufe.substring(props.Movimiento.cufe.length / 2, props.Movimiento.cufe.length)}<br />

                                    </Col>


                                }

                            </Col>
                            <Col sm={4} style={{ textAlign: 'center', fontSize: props.plantillapdf.tamanoletraencabezado, fontWeight: 'normal', color: props.plantillapdf.colorletra }}>
                                {props.tipodocumento.consecfac}<br />
                                {((props.tipodocumento.tipodoc == "devoluciones" || props.tipodocumento.tipodoc == "nota debito") ? props.tipodocumento.codigo : props.tipodocumento.prefijo) + '-' + props.Movimiento.ndocumento}<br />

                                {props.plantillapdf.mostrarqr &&
                                    <QRCode size={100} value={props.Movimiento.qr ? props.Movimiento.qr : ""} />

                                }



                            </Col>
                            {!props.plantillapdf.ponerlineas && <Col sm={4} style={{ textAlign: 'left', fontSize: props.plantillapdf.tamanoletraencabezado, fontWeight: 'normal', color: props.plantillapdf.colorletra, fontFamily: 'Arial,monospace' }}>
                                {props.plantillapdf.nombrecliente && "Señores: " + props.Movimiento.nombrecli}{props.plantillapdf.nombrecliente && (<br />)}
                                {props.plantillapdf.nitcliente && "Nit: " + props.Movimiento.cliente}{props.plantillapdf.nitcliente && (<br />)}
                                {"Telefono: " + (props.tercero && props.tercero.tel1)}<br />
                                {props.plantillapdf.usuariohizofactura && "Cajero: " + props.Movimiento.nomusuario}{props.plantillapdf.usuariohizofactura && (<br />)}
                                {props.plantillapdf.usuarioactual && "Cajero: " + props.dataUser.usuario.nombre}{props.plantillapdf.usuarioactual && (<br />)}
                                {props.plantillapdf.codigovendedor && "Cod. Vendedor: " + props.Movimiento.vendedor}{props.plantillapdf.codigovendedor && (<br />)}
                                {props.plantillapdf.nombrevendedor && "Vendedor: " + props.Movimiento.nombreven}{props.plantillapdf.nombrevendedor && (<br />)}

                            </Col>}
                            {props.plantillapdf.ponerlineas &&
                                <Col
                                    sm={4}
                                    style={{
                                        textAlign: 'left',
                                        fontSize: props.plantillapdf.tamanoletraencabezado,
                                        fontWeight: 'normal',
                                        color: props.plantillapdf.colorletra,
                                        border: '1px solid black', // Borde externo (opcional)
                                        padding: '10px'
                                    }}
                                >
                                    {props.plantillapdf.nombrecliente && (
                                        <div style={{ borderBottom: '1px solid black', fontFamily: 'Arial,monospace' }}>
                                            {"Señores: " + props.Movimiento.nombrecli}
                                        </div>
                                    )}
                                    {props.plantillapdf.nitcliente && (
                                        <div style={{ borderBottom: '1px solid black' }}>
                                            {"Nit: " + props.Movimiento.cliente}
                                        </div>
                                    )}
                                    <div style={{ borderBottom: '1px solid black' }}>
                                        {"Telefono: " + (props.tercero && props.tercero.tel1)}
                                    </div>
                                    {props.plantillapdf.usuariohizofactura && (
                                        <div style={{ borderBottom: '1px solid black' }}>
                                            {"Cajero: " + props.Movimiento.nomusuario}
                                        </div>
                                    )}
                                    {props.plantillapdf.usuarioactual && (
                                        <div style={{ borderBottom: '1px solid black' }}>
                                            {"Cajero: " + props.dataUser.usuario.nombre}
                                        </div>
                                    )}
                                </Col>
                            }

                            {props.plantillapdf.ponerlineas ?
                                <Col
                                    sm={4}
                                    style={{
                                        textAlign: 'left',
                                        fontSize: props.plantillapdf.tamanoletraencabezado,
                                        fontWeight: 'normal',
                                        color: props.plantillapdf.colorletra,
                                        border: '1px solid black', // Borde externo (opcional)
                                        padding: '10px' // Opcional: espacio interno
                                    }}
                                >
                                    <div style={{ borderBottom: '1px solid black', padding: '5px 0' }}>
                                        {"Departamento: " + (props.tercero && props.tercero.pais)}
                                    </div>
                                    <div style={{ borderBottom: '1px solid black', padding: '5px 0' }}>
                                        {"Ciudad: " + (props.tercero && (props.tercero.municipio + "-" + props.tercero.nompais))}
                                    </div>
                                    {props.plantillapdf.direccioncliente && (
                                        <div style={{ borderBottom: '1px solid black', padding: '5px 0' }}>
                                            {"Direccion: " + (props.tercero && props.tercero.direccion)}
                                        </div>
                                    )}
                                    <div style={{ borderBottom: '1px solid black', padding: '5px 0' }}>
                                        {"Email: " + (props.tercero && props.tercero.email)}
                                    </div>
                                </Col> : <Col
                                    sm={4}
                                    style={{
                                        textAlign: 'left',
                                        fontSize: props.plantillapdf.tamanoletraencabezado,
                                        fontWeight: 'normal',
                                        color: props.plantillapdf.colorletra,
                                    }}
                                >
                                    {"Departamento: " + (props.tercero && props.tercero.pais)}
                                    {"Ciudad: " + (props.tercero && (props.tercero.municipio + "-" + props.tercero.nompais))}
                                    {props.plantillapdf.direccioncliente && (
                                        <div >
                                            {"Direccion: " + (props.tercero && props.tercero.direccion)}
                                        </div>
                                    )}
                                    {"Email: " + (props.tercero && props.tercero.email)}
                                </Col>

                            }
                            <Col sm={4} style={{ textAlign: 'center', fontSize: props.plantillapdf.tamanoletraencabezado, fontWeight: 'normal', color: props.plantillapdf.colorletra }}>
                                {props.plantillapdf.horafecha && ("Fecha: " + props.Movimiento.horafecha)}{props.plantillapdf.horafecha && (<br />)}
                                {props.plantillapdf.fecha && ("Fecha: " + props.Movimiento.fecha)}{props.plantillapdf.fecha && (<br />)}
                                {"Fecha Vencimiento: " + props.Movimiento.fechpost}<br />
                                {
                                    props.notascredito2.map((dato) => {
                                        return <Col sm={12}>
                                            <Button style={{ fontSize: '12px', backgroundColor: '#ffa1eb', color: props.plantillapdf.colorletra }} block onClick={() => {

                                            }} >
                                                <i >{dato.concepto + " - " + dato.ndocumento}</i> </Button>
                                        </Col>
                                    })
                                }
                                {props.Movimiento.documento1 != "" && props.tipodocumento.captiondoc1 + ": " + props.Movimiento.documento1}<br />
                                {props.Movimiento.documento2 != "" && props.tipodocumento.captiondoc2 + ": " + props.Movimiento.documento2}<br />
                            </Col>
                        </Row>
                        <Row >
                            <Col sm={12}>
                                <Table size="sm" className='custom-table'>
                                    <thead>
                                        <tr style={{ fontSize: props.plantillapdf.tamanoletraencabezadogrilla, color: props.plantillapdf.colorletra }}>
                                            <th style={{ width: '1%' }}>Item</th>
                                            <th style={{ width: '20%' }}>Descr</th>
                                            {props.tipodocumento.lotes == "si" && <th style={{ width: '10%' }} >Lote</th>}
                                            {props.tipodocumento.lotes == "si" && <th style={{ width: '10%' }} >F.V.Lote</th>}
                                            <th style={{ width: '10%' }}>Cant</th>
                                            <th style={{ width: '10%' }}>Vr.Total</th>
                                            <th style={{ width: '10%' }}>iva</th>
                                            <th style={{ width: '10%' }}>Vr.Total</th>

                                        </tr>
                                    </thead>
                                    {!props.plantillapdf.ponerlineas && <tbody>
                                        {
                                            (props.Movimiento.famovimiento.length < 1) ? (
                                                <tr>
                                                    <td colSpan="15">Sin Datos</td>
                                                </tr>
                                            ) :
                                                (
                                                    props.Movimiento.famovimiento.filter(p => p.referencia != "").map((item, index) => (
                                                        <tr style={{ fontSize: props.plantillapdf.tamanoletraitemsgrilla, color: props.plantillapdf.colorletra, fontFamily: 'Arial,monospace' }} key={item.item}>

                                                            <td style={{ textAlign: 'left' }} >{index + 1}</td>
                                                            <td style={{ textAlign: 'left', whiteSpace: 'pre-line', fontFamily: 'Arial,monospace' }} > {item.referencia + " - "}{item.desadicional && item.desadicional !== "" ? (item.descrip + " " + item.desadicional) : item.descrip}</td>
                                                            {props.tipodocumento.lotes == "si" && <td style={{ textAlign: 'left' }} >{item.lote}</td>}
                                                            {props.tipodocumento.lotes == "si" && <td style={{ textAlign: 'left' }} >{item.fechavenclote}</td>}

                                                            <td style={{ textAlign: 'left' }} >{item.cantidad}</td>
                                                            <td style={{ textAlign: 'left' }}>{fm.from(item.precio * 1)}</td>
                                                            <td style={{ textAlign: 'left' }} >{item.poriva}</td>
                                                            <td style={{ textAlign: 'left' }}>{fm.from(item.subtotal)}</td>



                                                        </tr>
                                                    ))
                                                )


                                        }
                                    </tbody>}
                                    {props.plantillapdf.ponerlineas &&
                                        <tbody>
                                            {
                                                (props.Movimiento.famovimiento.length < 1) ? (
                                                    <tr>
                                                        <td colSpan="15" style={{ textAlign: 'center' }}>Sin Datos</td>
                                                    </tr>
                                                ) : (
                                                    props.Movimiento.famovimiento.filter(p => p.referencia !== "").map((item, index) => (
                                                        <tr style={{ fontSize: props.plantillapdf.tamanoletraencabezadogrilla, color: props.plantillapdf.colorletra }} key={item.item}>
                                                            <td style={{ textAlign: 'left', border: '1px solid black' }}>{index + 1}</td>
                                                            <td style={{ textAlign: 'left', whiteSpace: 'pre-line', border: '1px solid black' }}>
                                                                {item.referencia + " - "}{item.desadicional && item.desadicional !== "" ? (item.descrip + " " + item.desadicional) : item.descrip}
                                                            </td>
                                                            {props.tipodocumento.lotes == "si" && <td style={{ textAlign: 'left' }} >{item.lote}</td>}
                                                            {props.tipodocumento.lotes == "si" && <td style={{ textAlign: 'left' }} >{item.fechavenclote}</td>}
                                                            <td style={{ textAlign: 'left', border: '1px solid black' }}>{item.cantidad}</td>
                                                            <td style={{ textAlign: 'left', border: '1px solid black' }}>{fm.from(item.precio * 1)}</td>
                                                            <td style={{ textAlign: 'left', border: '1px solid black' }}>{item.poriva}</td>
                                                            <td style={{ textAlign: 'left', border: '1px solid black' }}>{fm.from(item.subtotal)}</td>
                                                        </tr>
                                                    ))
                                                )
                                            }
                                        </tbody>
                                    }
                                </Table>

                            </Col>

                        </Row>
                        {
                            // props.plantillapdf.mostrarunidadestotalesitems &&
                            true &&
                            <Row>
                                <Col sm={12} style={{ textAlign: 'left', fontSize: '10px', color: props.plantillapdf.colorletra }}>
                                    {"Items:" + props.Movimiento.famovimiento.length + tabespacio + tabespacio + tabespacio + tabespacio + tabespacio + tabespacio + tabespacio}
                                    {"Unidades:" + totalunidades() + tabespacio + tabespacio + tabespacio + tabespacio}
                                    {"Medio de Pago:" + tabespacio + buscarnombremediopago(props.Movimiento.mpago) + tabespacio + tabespacio + tabespacio + tabespacio}
                                    {"Forma de Pago:" + tabespacio + (props.tipodocumento.afecar != "" ? "Credito" : (props.tipodocumento.afecaj != "" && props.tipodocumento.afecaj != "nada") ? "Contado" : "") + tabespacio + tabespacio + tabespacio + tabespacio}
                                    {props.tipodocumento.tipodoc == "devoluciones" ? "Factura devolucion:" + props.tipodocumento.prefijo + props.Movimiento.ndocumentodevo : ""}
                                    {props.tipodocumento.tipodoc == "nota debito" ? "Factura Nota:" + props.tipodocumento.prefijo + props.Movimiento.ndocumentodevo : ""}
                                </Col>


                            </Row>
                        }

                        <Row>
                            <Col sm={12} style={{ fontSize: props.plantillapdf.tamanoletratotales, color: props.plantillapdf.colorletra }}>
                                <Table size="sm">
                                    <thead>

                                    </thead>
                                    <tbody >
                                        <tr  >
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Subtotal:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.bruto)}</th>
                                        </tr>
                                        {props.descuento != 0 &&
                                            <tr>
                                                {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                                <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Descuento:"}</th>
                                                <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.descuento)}</th>
                                            </tr>
                                        }
                                        {props.descuento != 0 &&
                                            <tr>
                                                {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                                <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Base:"}</th>
                                                <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.subTotal)}</th>
                                            </tr>
                                        }

                                        {(props.tipodocumento.ivasn != "no" && props.iva != 0 && props.plantillapdf.totaliva) && <tr>
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Iva:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.iva)}</th>
                                        </tr>

                                        }
                                        {
                                            props.plantillapdf.ivadiscriminado && ivadiscriminado.map((dato) => {
                                                return <tr>
                                                    {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                                    <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Iva " + dato.porcentaje + " : "}</th>
                                                    <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(dato.valor)}</th>
                                                </tr>
                                            })
                                        }
                                        {(props.tipodocumento.imptosn != "no" && props.consumo != 0) && <tr>
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Impo Consumo:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.consumo)}</th>
                                        </tr>

                                        }
                                        {(props.tipodocumento.rete != "no" && props.retefuente != 0) && <tr>
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Rte Fte:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.retefuente)}</th>
                                        </tr>

                                        }
                                        {(props.tipodocumento.reteiva != "no" && props.reteiva != 0) && <tr>
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Rte Iva:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.reteiva)}</th>
                                        </tr>

                                        }

                                        {(props.tipodocumento.ica != "no" && props.reteica != 0) && <tr>
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Rte Ica:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm2.from(props.reteica)}</th>
                                        </tr>

                                        }
                                        <tr>
                                            {props.plantillapdf.acercartextototales && <th style={{ textAlign: 'right', color: 'white', fontWeight: 'normal' }}>{"una grilla muy larga para que quepan los totales"}</th>}
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{"Neto:"}</th>
                                            <th style={{ textAlign: 'right', color: props.plantillapdf.colorletra, fontWeight: 'normal' }}>{tabespacio + fm.from(props.total)}</th>
                                        </tr>
                                    </tbody>
                                </Table>


                            </Col>
                            <Col sm={12} style={{ textAlign: 'left', fontSize: '13px', color: props.plantillapdf.colorletra, whiteSpace: 'pre-line', fontFamily: 'Kelpt A2 Medio, monospace' }}>
                                {"Observaciones:"}<br />
                                {(props.tipodocumento.camdescpp && props.tipodocumento.camdescpp.replace(' ', tabespacio) + tabespacio) + props.Movimiento.observacion}

                            </Col>
                        </Row>
                        {props.plantillapdf.mostrarformasdepago && <Row>
                            <Col sm={12} sty le={{ textAlign: 'center', fontSize: props.plantillapdf.tamanoletraformapagotitulo }}>
                                <Row>
                                    <Col sm={3}>
                                        -----
                                    </Col>
                                    <Col sm={6} style={{ fontSize: props.plantillapdf.tamanoletraformapagotitulo, color: props.plantillapdf.colorletra }}>
                                        Formas de Pago
                                    </Col>
                                    <Col sm={3}>
                                        -----
                                    </Col></Row>
                                {props.valorescaja.map((dato) => {
                                    return <>
                                        <Row style={{ color: props.plantillapdf.colorletra, fontSize: props.plantillapdf.tamanoletraformapago }}>
                                            <Col sm={4} style={{ textAlign: 'left' }}>
                                                {dato.formapago.toUpperCase()}
                                            </Col>
                                            <Col sm={4} style={{ fontSize: props.plantillapdf.tamanoletraformapago }}>

                                            </Col>
                                            <Col sm={4} style={{ textAlign: 'left' }}>
                                                {fm.from(dato.valor)}
                                            </Col></Row>
                                    </>
                                })}

                            </Col>

                        </Row>}

                        {props.plantillapdf.firmar &&
                            <>
                                <Row style={{ marginTop: '40px' }}>
                                    <Col sm={2} >

                                    </Col>
                                    <Col sm={2} >

                                    </Col>
                                    <Col sm={2} style={{ border: '1px solid black', width: '300px', color: 'white' }}>

                                    </Col>
                                    <Col sm={1} >

                                    </Col>
                                    <Col sm={2} style={{ border: '1px solid black' }}>

                                    </Col>
                                    <Col sm={3} >

                                    </Col>
                                </Row >
                                <Row >
                                    <Col sm={2} >

                                    </Col>
                                    <Col sm={2} >

                                    </Col>
                                    <Col sm={2} style={{ fontSize: '10px', color: 'black' }} >
                                        { JSON.parse(props.user).empresa.empresa.nombre}<br />
                                    </Col>
                                    <Col sm={1} >

                                    </Col>
                                    <Col sm={2} style={{ fontSize: '10px', color: 'black' }} >
                                        ACEPTADA, FIRMA Y SELLO
                                    </Col>
                                </Row></>
                        }
                        <Row>
                            {
                                props.plantillapdf.resolucion &&
                                <Col sm={12} style={{ textAlign: 'center', fontSize: '10px', fontWeight: 'normal', color: props.plantillapdf.colorletra }}>
                                    {"Resolución DIAN Facturación Electrónica No. " + props.tipodocumento.num_res + " de " + props.tipodocumento.inicresolu + ".Rango autorizado del " + props.tipodocumento.prefijo + props.tipodocumento.rango_res_i + " al " + props.tipodocumento.prefijo + props.tipodocumento.rango_res_f + ".Valido hasta " + props.tipodocumento.vencresolu}


                                </Col>
                            }

                            <Col sm={12} style={{ textAlign: 'center', fontSize: '10px', color: props.plantillapdf.colorletra }}>
                                {props.tipodocumento.tipodoc == "factura" ? "Gracias Por Su Compra" : props.tipodocumento.tipodoc == "compra" ? "Gracias por su Venta" : ""}<br />
                                {"Generado por Solifactin S.A.S"}<br />
                                {"Tenemos las mejores soluciones a su alcance"}<br />
                                {"www.factin.com.co"}<br />
                                {"Cel: 3187653564 - 3218561024"}<br />


                            </Col>

                        </Row>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Col sm={6}>
                    <FormGroup>
                        {props.certificado.map((data) => {
                            return <><Label>{data.nombre}</Label><Label>{tabespacio + tabespacio + tabespacio + tabespacio}</Label></>

                        })}
                    </FormGroup>
                </Col>
                <Col sm={3}>
                    <FormGroup>
                        <Label>Adjuntar</Label>
                        <Input bsSize="sm" type={"file"} onChange={async (e) => {
                            var archivoxml = e.target.files[0]
                            var cerbase64 = await props.base64certificado(archivoxml)
                            var adjuntos = props.certificado.map((data) => {
                                return data
                            })
                            adjuntos.push({
                                nombre: archivoxml.name,
                                adjunto: cerbase64
                            })
                            props.setcertificado(adjuntos)

                        }} >


                        </Input>
                    </FormGroup>
                </Col>
                <Button size="sm" color="primary" onClick={() => {
                    props.setprevisualizarenviocorreo(true)
                    props.setcorreosenvio(props.tercero && props.tercero.email)
                }}>Enviar Correo</Button>
                <Button size="sm" color="primary" onClick={() => {

                    props.previsualizarpdf()
                    // setprevisualizarelectronica(false)
                }}>PDF</Button>
                <Button size="sm" color="primary" onClick={() => {
                    props.setprevisualizar(false)
                    props.setcertificado([])
                }}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    )
}
export default Tipopodf;
